import PropTypes from 'prop-types'

import { cn } from '@/utils/helpers'

import { Label } from '../elements/label'
import { RadioGroup, RadioGroupItem } from '../elements/radio-group'

function CustomRadioGroup({ options, onChange, large = false, id, ...rest }) {
  return (
    <RadioGroup id={id} {...rest} onValueChange={onChange}>
      {options.map((option) => (
        <div className="flex items-center gap-3" key={option.id}>
          <RadioGroupItem large={large} value={option.id} id={`${id}-${option.id}`} />
          <Label className={cn(large ? 'text-2xl' : 'text-sm')} htmlFor={`${id}-${option.id}`}>
            {option.label}
          </Label>
        </div>
      ))}
    </RadioGroup>
  )
}

export default CustomRadioGroup

CustomRadioGroup.propTypes = {
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  large: PropTypes.bool,
}
